import { IComponentOptions, IRootScopeService } from "angular";
import { GtmhubController } from "@gtmhub/core";
import { SizeOfGif } from "@gtmhub/shared/services/tenor-gif.service";
import { CommentService, IComment } from "@gtmhub/comments";
import { getCurrentUserId, hasCurrentUserRole } from "@gtmhub/users";
import { localize } from "@gtmhub/localization";
import { WarningModalService } from "@gtmhub/shared/components";
import { UIErrorHandlingService } from "@gtmhub/error-handling";

export class FeedCommentComponentCtrl extends GtmhubController {
  public readonly sizeOfGif = SizeOfGif;

  public commentData: IComment;

  public isEdited = false;
  public onEditorOpen: (params: { commentId: string }) => void;

  get commentEditedLabel(): string {
    return `(${localize("edited")})`;
  }

  get isCurrentUserAdmin(): boolean {
    return hasCurrentUserRole("admin");
  }

  get isCurrentUserCommentAuthor(): boolean {
    return this.commentData.createdBy === getCurrentUserId();
  }

  public static $inject = ["$rootScope", "WarningModalService", "CommentService", "UIErrorHandlingService"];

  constructor(
    private $rootScope: IRootScopeService,
    private modalService: WarningModalService,
    private commentService: CommentService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    super();
  }

  public openInlineEditor(): void {
    this.isEdited = true;
    this.onEditorOpen({ commentId: this.commentData.id });
  }

  public closeInlineEditor(): void {
    this.isEdited = false;
  }

  public openCommentDeleteConfirmation(): void {
    this.closeInlineEditor();
    this.modalService
      .warningModal({
        modalImage: "/dist/img/confirm-delete.svg",
        modalTitle: "confirm_delete_comment",
        modalText: null,
        confirmBtnType: "destructive",
        confirmText: "delete",
        dismissText: "cancel",
      })
      .then(() =>
        this.commentService
          .delete(this.commentData.targetId)
          .then(() => this.$rootScope.$broadcast("commentDeleted", this.commentData))
          .catch((error) => this.uiErrorHandlingService.handleModal(error))
      );
  }

  public onCommentEdited(comment: IComment): void {
    this.$rootScope.$broadcast("commentEdited", comment);
  }
}

export const FeedCommentComponent: IComponentOptions = {
  bindings: {
    commentData: "<",
    usersIdMap: "<",
    onMessageClick: "&",
    isEdited: "<?",
    onEditorOpen: "&",
    editable: "<",
  },
  controller: FeedCommentComponentCtrl,
  templateUrl: require("./feed-comment.jade"),
};
